<script setup lang="ts">
import { computed } from 'vue';
import { avatarColor, initials } from '../profiles/registry';
import { onAccent } from '../theme';

/** A profile's picture, or its initials on a colour of its own. */
const props = withDefaults(defineProps<{ id: string; firstName: string; lastName?: string; avatar?: string; size?: number }>(), { lastName: '', avatar: '', size: 40 });
const bg = computed(() => avatarColor(props.id || props.firstName));
const ink = computed(() => onAccent(bg.value));
</script>

<template>
  <span class="avatar" :style="{ width: size + 'px', height: size + 'px', fontSize: Math.round(size * 0.38) + 'px', background: avatar ? undefined : bg, color: ink }" aria-hidden="true">
    <img v-if="avatar" :src="avatar" alt="" />
    <template v-else>{{ initials({ firstName, lastName }) }}</template>
  </span>
</template>

<style scoped>
.avatar {
  flex: none;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  overflow: hidden;
  font-weight: 650;
  letter-spacing: 0.02em;
  user-select: none;
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
